import styled, { css } from 'styled-components';
import { ALabelSize, type ALabelProps } from './ALabel.types';

type StyleProps = Omit<ALabelProps, 'text'>;

const stylesBySize = ({ size }: StyleProps) => {
  switch (size) {
    case ALabelSize.XS:
      return css`
        font-size: 0.75rem;
      `;
    case ALabelSize.S:
      return css`
        font-size: 0.875rem;
      `;
    case ALabelSize.M:
    default:
      return css`
        font-size: 1rem;
      `;
  }
};

export const ALabelWrapper = styled.span<StyleProps>`
  color: var(--t-brand-fg-color);
  font-family: var(--t-font-family);
  font-weight: 700;
  line-height: 1;
  display: inline-block;
  ${stylesBySize}

  &.m-ellipsis-1line {
    // override
    line-height: 1;
    display: inline-block;
  }
`;
